import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/ws_accounts', { params })
}

/**
 * 获取登录二维码
 *
 * @param params
 */
export const login = (params = {}): AxiosPromise => {
  return axios.get('/ws_accounts/login', { params })
}

export const confirmed = (params = {}): AxiosPromise => {
  return axios.get('/ws_accounts/confirmed', { params })
}
